import Cookie from "js-cookie";
import { serverErrorMessage } from "../constants/Constants";

export const ApiGateWay = {
  Post,
  Get,
  paramsPost,
  Token,
  PostCall,
  PostCallParam,
  GetData,
  SaveData,
  PostCall1,
  ExternalToken,
  PostEmp,
  GetAsset,
  SimpleGet,
  SimplePost,
  SimplePut,
  SimpleDelete,
  SimpleMultipartPost,
  newSimpleMultipartPost,
  BlobUrlGet,
  newSimplePost,
  newSimplePut,
  newSimpleGet,
  updateStateForApi,
};
function Post(url, payload, token) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(Cookie.get("token")),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
    body: JSON.stringify(payload),
  };

  return fetch(process.env.REACT_APP_SERVER + url, requestOptions).then(
    (res) => {
      return res;
    }
  );
}
function GetAsset(url, payload) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(payload);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  console.log(url, "url");
  return fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => result)
    .catch((error) => console.log("error", error));
}

function Get(payload, token) {
  const requestOptions = {
    crossDomain: true,
    method: "GET",
    headers: {
      Authorization: "Bearer " + JSON.parse(Cookie.get("token")),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
    },
  };

  return fetch(process.env.REACT_APP_SERVER + payload, requestOptions).then(
    (res) => {
      return res;
    }
  );
}

function paramsPost(url, token) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
  };

  return fetch(process.env.REACT_APP_SERVER + url, requestOptions)
    .then((res) => {
      if (token) {
        return res;
      } else {
        //return (window.location = '/');
      }

      // return res;
    })
    .then((res) => res.json());
}

function PostCall(url, payload) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    // mode: 'no-cors',
    cache: "no-cache",
    referrerPolicy: "no-referrer",
    headers: {
      Authorization: "Bearer " + Cookie.get("token"),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions).then((res) => {
    return res;
  });
}

function Token(url, data) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    mode: "no-cors",
    cache: "no-cache",
    referrerPolicy: "no-referrer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
    body: JSON.stringify(data),
  };

  return fetch(url, requestOptions).then((res) => {
    return res.json();
  });
}
function ExternalToken(url, data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // 'x-api-key': 'c00fe389-a98f-4a83-879c-1d21a415d2ed',
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
    body: JSON.stringify(data),
  };

  return fetch(url, requestOptions).then((res) => {
    return res.json();
  });
}

function PostCallParam(url, token) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    mode: "no-cors",
    cache: "no-cache",
    referrerPolicy: "no-referrer",
    headers: {
      Authorization: "Bearer " + token,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
  };

  return fetch(url, requestOptions)
    .then((res) => {
      if (token) {
        return res;
      } else {
      }
    })
    .then((res) => res.json());
}

function GetData(url) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    // credentials: 'include',
    cache: "no-cache",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json",
    },
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json());
}

function SaveData(url, data) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json());
}

function PostCall1(url, payload) {
  var formBody = [];
  for (var property in payload) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(payload[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  console.log(formBody);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: formBody,
  };
  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json());
}

function PostEmp(payload, token) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(Cookie.get("token")),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
    },
  };

  return fetch(process.env.REACT_APP_SERVER + payload, requestOptions).then(
    (res) => {
      return res;
    }
  );
}

function BlobUrlGet(url) {
  const requestOptions = {
    crossDomain: true,
    method: "GET",
    responseType: "blob",
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res.blob();
    })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
}

function SimpleGet(url) {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  const requestOptions = {
    crossDomain: true,
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
    },
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json())
    .catch((err) => {
      throw err;
    });
}

function SimplePost(url, payload) {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + token,
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json())
    .catch((err) => {
      throw err;
    });
}

function SimpleMultipartPost(url, payload) {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + token,
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Access-Control-Allow-Origin": "*",
    },
    body: payload,
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json())
    .catch((err) => {
      throw err;
    });
}

function SimplePut(url, payload) {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  const requestOptions = {
    crossDomain: true,
    method: "PUT",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + token,
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res;
    })
    .then((res) => res.json())
    .catch((err) => {
      throw err;
    });
}

function SimpleDelete(url) {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  const requestOptions = {
    crossDomain: true,
    method: "DELETE",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + token,
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      if (!!res.error && res.status >= 400) {
        throw res;
      } else {
        return res;
      }
    })
    .catch((err) => {
      throw err;
    });
}
function newSimplePost(url, payload) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + getToken(),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      return checkStatusCode(res);
    })
    .catch((err) => {
      throw err;
    });
}
function newSimplePut(url, payload) {
  const requestOptions = {
    crossDomain: true,
    method: "PUT",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + getToken(),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      return checkStatusCode(res);
    })
    .catch((err) => {
      throw err;
    });
}
function newSimpleMultipartPost(url, payload) {
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + getToken(),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Access-Control-Allow-Origin": "*",
    },
    body: payload,
  };
  return fetch(url, requestOptions)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      return checkStatusCode(res);
    })
    .catch((err) => {
      throw err;
    });
}
function newSimpleGet(url, payload) {
  const requestOptions = {
    crossDomain: true,
    method: "GET",
    referrerPolicy: "no-referrer",
    headers: {
      Accept: "application/json, text/plain",
      Authorization: "Bearer " + getToken(),
      "x-api-key": process.env.REACT_APP_X_API_KEY,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      return checkStatusCode(res);
    })
    .catch((err) => {
      throw err;
    });
}
function isJSONString(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

function getToken() {
  let token = Cookie.get("token");
  if (isJSONString(token)) {
    token = JSON.parse(token);
  }
  return token;
}

function checkStatusCode(res) {
  if (!!res.error && res.status >= 500) {
    const response = {
      ...res,
      error: serverErrorMessage,
    };
    throw response;
  } else {
    return res;
  }
}

function updateStateForApi(
  loading,
  modalOpen,
  apiStatus,
  message,
  dispatch,
  APIStart,
  initialState
) {
  const updatedState = {
    ...initialState,
    loading,
    modalOpen,
    apiStatus,
    message,
  };
  dispatch(APIStart(updatedState));
}
